import React, { Component } from "react";
import PropTypes from "prop-types";

import Form from "theme/components/atoms/Form/Form";
import CustomOption from "./CustomOption";
import OptionPicker from "./OptionPicker";
import BundleOption from "./BundleOption/BundleOption";
import Stack from "theme/components/atoms/Layout/Stack";

class Configurator extends Component {
  constructor() {
    super();
    this.onChangeOptions = this.onChangeOptions.bind(this);
    this.onChangeCustomOptions = this.onChangeCustomOptions.bind(this);
    this.onChangeBundleOptions = this.onChangeBundleOptions.bind(this);
  }

  initOptions() {
    if (!this.hasInitOptions && this.optionsForm) {
      this.hasInitOptions = true;
      this.onChangeOptions();
    }
  }
  initCustomOptions() {
    if (!this.hasInitCustomOptions && this.customOptionsForm) {
      this.hasInitCustomOptions = true;
      this.onChangeCustomOptions();
    }
  }
  initBundleOptions() {
    if (!this.hasInitBundleOptions && this.bundleOptionsForm) {
      this.hasInitBundleOptions = true;
      this.onChangeBundleOptions();
    }
  }

  onChangeOptions() {
    const model = this.optionsForm.getModel();
    Object.keys(model)
      .filter((key) => typeof model[key] !== "undefined")
      .forEach((option) =>
        this.props.setOption(option, model[option].value || model[option])
      );
  }

  onChangeCustomOptions() {
    const model = this.customOptionsForm.getModel();
    Object.keys(model)
      .filter((key) => typeof model[key] !== "undefined")
      .forEach((option) => {
        const customOptionValue = model[option].value || model[option];
        this.props.setCustomOption(
          option,
          customOptionValue ? customOptionValue : null
        );
      });
  }

  onChangeBundleOptions() {
    const model = this.bundleOptionsForm.getModel();
    Object.keys(model)
      .filter((key) => typeof model[key] !== "undefined")
      .forEach((option) => {
        this.props.setBundleOption(option, {
          values: model[option].values.filter(Boolean),
          quantity: model[option].quantity,
        });
      });
  }

  render() {
    const customOptions = this.props.customOptions.map((option, index) => {
      return (
        <CustomOption
          key={index}
          option={option}
          selectedOption={this.props.selectedCustomOptions[option.option_id]}
        />
      );
    });
    const optionsPickers = this.props.options.map((option, index) => {
      return (
        <OptionPicker
          key={index}
          option={option}
          selectedOption={this.props.selectedOptions[option.id]}
        />
      );
    });
    const bundleOptions = this.props.bundleOptions.map((option, index) => {
      return (
        <BundleOption
          key={index}
          option={option}
          selectedValue={this.props.selectedBundleOptions[option.id]}
        />
      );
    });

    return (
      <div className="configurator">
        <Stack size="2">
          {optionsPickers.length ? (
            <Form
              key="options"
              setRef={(form) => {
                this.optionsForm = form;
                if (form) {
                  this.initOptions();
                }
              }}
              onChange={this.onChangeOptions}
            >
              <Stack size="2">{optionsPickers}</Stack>
            </Form>
          ) : null}

          {bundleOptions.length ? (
            <Form
              key="bundleOptions"
              setRef={(form) => {
                this.bundleOptionsForm = form;
                if (form) {
                  this.initBundleOptions();
                }
              }}
              onChange={this.onChangeBundleOptions}
            >
              <Stack size="2">{bundleOptions}</Stack>
            </Form>
          ) : null}

          {customOptions.length ? (
            <Form
              key="customOptions"
              setRef={(form) => {
                this.customOptionsForm = form;
                if (form) {
                  this.initCustomOptions();
                }
              }}
              onChange={this.onChangeCustomOptions}
            >
              <Stack size="2">{customOptions}</Stack>
            </Form>
          ) : null}
        </Stack>
      </div>
    );
  }
}

Configurator.propTypes = {
  options: PropTypes.array,
  initialOptions: PropTypes.object,
};

export default Configurator;
